<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Change Password"
      :text="name"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              v-if="oldPasswordRequired"
              cols="12"
            >
              <v-text-field
                v-model="oldPassword"
                v-validate="'required'"
                :error-messages="errors.collect('old_password')"
                data-vv-name="old_password"
                data-vv-as="old password"
                label="Current Password"
                type="password"
                autocomplete="new-password"
                counter         
                outlined   
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                ref="password"
                v-model="password"
                v-validate="'required'"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                data-vv-as="current password"
                label="New Password"
                type="password"
                autocomplete="new-password"
                outlined   
                counter            
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="confirmedPassword"
                v-validate="'required|confirmed:password'"
                :error-messages="errors.collect('confirmed_password')"
                data-vv-name="confirmed_password"
                data-vv-as="password"
                label="Re-type new password"
                type="password"
                autocomplete="new-password"
                counter
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 
      <v-col
        v-if="systemSettingValue === '1'"
        cols="12"
        class="px-6 pb-2 mt-n3"
      >
        <span class="dialog red--text">Kindly note that this password update only apply to this system.</span>
      </v-col>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="setDialog(false)"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"      
          class="white--text px-10"        
          @click="submitForm"
        >
          Update Password
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      oldPasswordRequired: {
        type: Boolean,
        default: true,
      },
      user: {
        type: Object,
        default: null,
      },
      systemSettingValue: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        oldPassword: null,
        password: null,
        confirmedPassword: null,
      }
    },
    computed: {
      name () {
        return (this.user || {}).name || ''
      },
    },
    watch: {
      dialog: function (status) {
        if (!status) {
          this.$validator.reset()
          this.$resetData()
        }
      },
    },
    methods: { 
      toggleDialog () {
        this.dialog = true
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
        
            this.$api.changePassword().update(this.user.user_uid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$snack({
                    message: this.name + "'s password is updated successfully",
                  })
                  this.setDialog(false)
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
   
      prepareFormData () {
        return {
          password: this.password,
          ...(this.oldPasswordRequired && { old_password: this.oldPassword }),
        }
      },

      setDialog (status) {
        this.dialog = status
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>
